import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, COMPANY } from "../../lib/site-data";
import LogoPlaceholder from "./LogoPlaceholder";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100"
          : "bg-white border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#home" data-testid="header-logo-link" className="shrink-0">
            <LogoPlaceholder variant="light" testid="header-logo-placeholder" />
          </a>

          <nav
            className="hidden lg:flex items-center gap-8"
            data-testid="desktop-nav"
          >
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className="text-sm font-semibold text-[#1D2B53] hover:text-[#2563EB] transition-colors relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-[#2563EB] transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={COMPANY.phoneLink}
              data-testid="header-call-button"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold shadow-lg shadow-blue-500/20 transition-all hover:-translate-y-0.5"
            >
              <Phone className="h-4 w-4" />
              {COMPANY.phone}
            </a>
          </div>

          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden inline-flex items-center justify-center h-11 w-11 rounded-lg text-[#1D2B53] hover:bg-gray-100 transition-colors"
            aria-label="Toggle navigation"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div
            data-testid="mobile-nav"
            className="lg:hidden pb-6 pt-2 border-t border-gray-100"
          >
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                  className="px-3 py-3 rounded-lg text-base font-semibold text-[#1D2B53] hover:bg-gray-50 hover:text-[#2563EB] transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <a
                href={COMPANY.phoneLink}
                data-testid="mobile-call-button"
                className="mt-3 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold shadow-lg shadow-blue-500/20 transition-all"
              >
                <Phone className="h-4 w-4" />
                Call {COMPANY.phone}
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
